module.exports = __webpack_public_path__ + "static/7-01915bd584a34c1ef9c8a0e8db6da0d4.png";